<template>
    <div class="body">
        <div class="title">
            社团管理
            <!-- 面包屑导航区域 -->
            <div class="fansk">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/shouye' }"><span class="dsadf"> 首页 </span></el-breadcrumb-item>
                    <el-breadcrumb-item>社团管理</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/shangxiehuiguanli' }">社团管理</el-breadcrumb-item>
                    <el-breadcrumb-item>{{
            postType ? "修改社团" : "添加社团"
          }}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>

        <div style="margin: -20px 0 20px;">
            <el-button size="mini" @click="$router.back()">返回</el-button>
        </div>

        <div>
            <el-form ref="form" :model="addQuery" :rules="rules" label-position="left" label-width="110px" class="demo-ruleForm">
                <!-- <el-form-item label="社团类型" required>
                <el-radio-group v-model="addQuery.types">
                  <el-radio :label="1">社团</el-radio>
                  <el-radio :label="2">协会</el-radio>
                </el-radio-group>
              </el-form-item> -->
                <h4>申请信息</h4>
                <el-form-item label="社团全称" prop="org_com">
                    <el-input :disabled="is_mass_organizations_self" v-model="addQuery.org_com" style="width: 500px" placeholder="请输入社团全称" clearable></el-input>
                </el-form-item>
                <el-form-item label="赛事级别" prop="act_level">
                    <el-radio-group :disabled="is_mass_organizations_self" v-model="addQuery.act_level">
                      <el-radio label="1">大型赛事</el-radio>
                      <el-radio label="2">市本级</el-radio>
                      <el-radio label="3">区县级</el-radio>
                      <el-radio label="4">市社团</el-radio>
                      <el-radio label="5">区社团</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="所属区域" prop="org_areaid">
                    <!-- <el-cascader :disabled="is_mass_organizations_self" :value='areaArray' :props="checkedData.typeOptions" @change="changList"></el-cascader> -->
                    <el-cascader :disabled="is_mass_organizations_self" :value='areaArray' :options="allWzArea" :props="checkedData"  @change="changList"></el-cascader>
                </el-form-item>
                <el-form-item label="社团地址" prop="org_address">
                    <el-input v-model="addQuery.org_address" style="width: 500px" placeholder="请输入详细地址" clearable></el-input>
                </el-form-item>
                <el-form-item label="" prop="org_longitude">
                    <el-row style="margin-bottom: 10px">
                        <vxe-button size="medium" content="获取社团位置经纬度" status="primary" @click="GetJWD"></vxe-button>
                    </el-row>
                    <el-row style="margin-bottom: 10px">
                        <el-input v-model="addQuery.org_longitude" style="width: 500px" placeholder="请选择经度" disabled></el-input>
                    </el-row>
                    <el-row>
                        <el-input v-model="addQuery.org_latitude" style="width: 500px" placeholder="请选择纬度" disabled></el-input>
                    </el-row>
                </el-form-item>
                <el-form-item label="联系人姓名" prop="apply_realname">
                    <el-input v-model="addQuery.apply_realname" style="width: 500px" placeholder="请输入申请人姓名" clearable></el-input>
                </el-form-item>
                <el-form-item label="联系人电话" prop="org_mobile">
                    <el-input v-model="addQuery.org_mobile" type="text" style="width: 500px" placeholder="请输入社团联系人电话" clearable></el-input>
                </el-form-item>
                <!-- accoount -->
                <el-form-item label="社团登录账号" prop="account">
                    <el-input :disabled="is_mass_organizations_self" v-model="addQuery.account" type="text" style="width: 500px" placeholder="请输入社团登录账号，用于用户登录，默认密码bxydm@202304" clearable></el-input>
                </el-form-item>
                <el-form-item label="营业执照照片" label-width="10%" prop="org_license" :disabled="is_mass_organizations_self">
                    <div class="imgbox" v-if="addQuery.org_license">
                        <img :src="addQuery.org_license" alt="" class="imgs img-self" />
                        <img src="../assets/img/shanchu.png" mode="" class="close" @click="addQuery.org_license = ''" alt="">
                    </div>
                    <el-upload v-if="!addQuery.org_license" class="upload-demo" ref="upload" action="https://ydmxhapi.yundongm.cn:8099/service/admin/upload_pic" :on-progress="progress" :on-success="handleAvatarlicense" :limit="1" :before-upload="$beforeUploadImage" :on-exceed="handleExceed" list-type="picture" :data="{ token: token }" name="pic">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="社团LOGO" label-width="10%" prop="org_logo">
                    <div class="imgbox" v-if="addQuery.org_logo">
                        <img :src="addQuery.org_logo" alt="" class="imgs img-self" />
                        <img src="../assets/img/shanchu.png" mode="" class="close" @click="addQuery.org_logo = ''" alt="">
                    </div>
                    <el-upload v-if="!addQuery.org_logo" class="upload-demo" ref="upload" action="https://ydmxhapi.yundongm.cn:8099/service/admin/upload_pic" :on-progress="progress" :on-success="handleAvatarlogo" :limit="1" :before-upload="$beforeUploadImage" :on-exceed="handleExceed" list-type="picture" :data="{ token: token }" name="pic">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="主页背景" label-width="10%" prop="org_bgpic">
                    <div class="imgbox" v-if="addQuery.org_bgpic">
                        <img :src="addQuery.org_bgpic" alt="" class="imgs img-self" />
                        <img src="../assets/img/shanchu.png" mode="" class="close" @click="addQuery.org_bgpic = ''" alt="">
                    </div>
                    <el-upload v-if="!addQuery.org_bgpic" class="upload-demo" ref="upload" action="https://ydmxhapi.yundongm.cn:8099/service/admin/upload_pic" :on-progress="progress" :on-success="handleAvatarSuccess" :limit="1" :before-upload="$beforeUploadImage" :on-exceed="handleExceed" list-type="picture" :data="{ token: token }" name="pic">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
                <!-- <el-form-item label="社团视频" label-width="10%" required>
                    <div class="imgbox" v-if="addQuery.org_video">
                        <video :src="addQuery.org_video" class="imgs" @click="addQuery.org_video = ''"></video>
                    </div>
                    <el-upload v-if="!addQuery.org_video" class="upload-demo" ref="upload" action="/service/admin/uploadvideo" :on-progress="progress" :on-success="handleAvatarVideo" :limit="1" :before-upload="beforeUpload" :on-exceed="handleExceed" list-type="picture" :data="{token:token}" name='video'>
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item> -->
                <!-- <el-form-item label="社团相册" label-width="10%" required>
                    <div class="imgboxList">
                        <div v-for="(item, index) in addQuery.org_pics" :key="index" class="imgBox">
                            <img :src="item.name" mode="" class="imgs" alt="">
                        </div>
                    </div>
                    <el-upload v-if="addQuery.org_pics.length <= 9" class="upload-demo" ref="upload" action="/service/admin/upload_pic" :on-progress="progress" :on-success="handleAvatarPics" :limit="9" :before-upload="beforeUpload" :on-exceed="handleExceed" list-type="picture" :data="{token:token}" name='pic'>
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item> -->
                <el-form-item label="社团介绍" prop="org_remark">
                    <el-input type="textarea" v-model="addQuery.org_remark" placeholder="请输入社团介绍" style="width: 500px" clearable></el-input>
                </el-form-item>
                <!-- <el-form-item label="申请人姓名" prop="apply_realname">
                    <el-input :disabled="is_mass_organizations_self" v-model="addQuery.apply_realname" style="width: 500px" placeholder="请输入申请人姓名" clearable></el-input>
                </el-form-item>
                <el-form-item label="申请人电话" prop="apply_mobile">
                    <el-input :disabled="is_mass_organizations_self" v-model="addQuery.apply_mobile" style="width: 500px" placeholder="请输入申请人联系电话" clearable></el-input>
                </el-form-item> -->
                <el-form-item label="活动类型" prop="sport_type">
                    <el-checkbox-group v-model="checkSportTypesList">
                        <el-checkbox v-for="(item) in sportTypes" :label="item.id" :key="item.id">{{ item.title }}</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <!-- TIP: 活动场地, 暂时隐藏 -->
                <!-- <el-form-item label="活动场地" prop="site_type">
                  <el-select v-model="addQuery.site_type" multiple placeholder="请选择场地" filterable style="width:500px">
                    <el-option
                        v-for="item in sportSites"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                </el-form-item> -->
                <h4>基础信息</h4>
                <el-form-item label="发证机关" prop="issuing_authority">
                    <el-input :disabled="is_mass_organizations_self" v-model="addQuery.issuing_authority" style="width: 500px" placeholder="请输入发证机关" clearable></el-input>
                </el-form-item>
                <el-form-item label="法人" prop="legal_person">
                    <el-input :disabled="is_mass_organizations_self" v-model="addQuery.legal_person" style="width: 500px" placeholder="请输入法人" clearable></el-input>
                </el-form-item>
                <el-form-item label="信用代码" prop="credit_code">
                    <el-input :disabled="is_mass_organizations_self" v-model="addQuery.credit_code" style="width: 500px" placeholder="请输入信用代码" clearable></el-input>
                </el-form-item>
                <el-form-item label="成立日期" prop="created_date">
                    <el-date-picker :disabled="is_mass_organizations_self" style="width: 294px; min-width: 294px" type="date" v-model="addQuery.created_date" placeholder="选择成立日期" value-format="yyyy-MM-dd" tihuan>
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="注册住所" prop="reg_address">
                    <el-input :disabled="is_mass_organizations_self" v-model="addQuery.reg_address" style="width: 500px" placeholder="请输入注册住所" clearable></el-input>
                </el-form-item>
                <el-form-item label="证书有效日期" prop="checkDate">
                    <el-date-picker :disabled="is_mass_organizations_self" v-model="addQuery.checkDate" type="daterange" :editable="false" :clearable="false" value-format="yyyy-MM-dd" range-separator="至" @change="changeCheckDate" tihuan start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="注册资金" prop="reg_capital">
                    <el-input-number :disabled="is_mass_organizations_self" v-model="addQuery.reg_capital" style="width: 294px" placeholder="请输入注册资金（元）" clearable>
                        <!-- <template #append>元</template> -->
                    </el-input-number> 元
                </el-form-item>
                <el-form-item label="主管单位" prop="organizer">
                    <el-input :disabled="is_mass_organizations_self" v-model="addQuery.organizer" style="width: 500px" placeholder="请输入主管单位" clearable></el-input>
                </el-form-item>
                <el-form-item label="评估等级" prop="eva_level">
                    <el-select :disabled="is_mass_organizations_self" v-model="addQuery.eva_level" placeholder="选择评估等级" size="large">
                        <el-option v-for="item in starList" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </el-form-item>
                <el-form-item label="是否慈善组织" required>
                    <el-radio-group :disabled="is_mass_organizations_self" v-model="addQuery.is_charitable">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否支援组织" required>
                    <el-radio-group :disabled="is_mass_organizations_self" v-model="addQuery.is_support">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否获取公募资格" required>
                    <el-radio-group :disabled="is_mass_organizations_self" v-model="addQuery.is_public_equity">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="业务范围" prop="business_scope">
                    <el-input type="textarea" v-model="addQuery.business_scope" style="width: 500px" placeholder="请输入业务范围" clearable></el-input>
                </el-form-item>
                <el-form-item label="入会审核" required>
                    <el-radio-group v-model="addQuery.join_examine">
                        <el-radio :label="1">正常审核</el-radio>
                        <el-radio :label="2">无需审核</el-radio>
                    </el-radio-group>
                </el-form-item>

                <h4>组织架构</h4>
                <el-form-item label="组织架构" prop="organization">
                    <el-input type="textarea" v-model="addQuery.organization" style="width: 500px" placeholder="会长:姓名A" clearable></el-input>
                </el-form-item>

                <template v-if="!is_mass_organizations_self">
                  <h4>状态</h4>
                  <el-form-item label="状态" required>
                      <el-switch :inactive-value="0" :active-value="1" v-model="addQuery.is_status" active-text="上架" inactive-text="下架">
                      </el-switch>
                  </el-form-item>
                </template>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">{{ $route.query.id ? '修改保存' : '立即创建' }}</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!-- <Amap v-show="showMap" @onAddrConfirm="AddrConfirm" /> -->
        <Amap ref="AmapCom" @onAddrConfirm="AddrConfirm" />

        <!-- new amap -->
        <search-address ref="searchAddressRef" @onConfirm="AddrConfirm"></search-address>
    </div>
</template>

<script>
    import { area, city, province, getWzArea, getAllWzArea } from "@/api/city";
    import { addBusinessassociation, editBusinessassociation } from "@/api/new";
    import { shangxiehuixiangqing, getBusinessSportTypeList, getBusinessSportSiteList } from "@/api/shangxiehui";
    import Amap from "../components/Amap";
    import SearchAddress from "@/components/Amap/SearchAddress.vue"
    import waves from "../directive/waves";
    export default {
        name: "AddXiehui",
        directives: { waves },
        components: { Amap, SearchAddress },
        data() {
            return {
                allWzArea: [],
                source: '',
                sportTypes: [],
                checkSportTypesList: [],
                sportSites: [{
                  id: 1,
                  title: '默认'
                }],
                checkSportSitesList: [],
                areaArray: [],
                postType: 0,
                areaList: [],
                starList: [{
                    label: "1A",
                    value: "1A",
                }, {
                    label: "2A",
                    value: "2A",
                }, {
                    label: "3A",
                    value: "3A",
                }, {
                    label: "4A",
                    value: "4A",
                }, {
                    label: "5A",
                    value: "5A",
                }, ],
                token: sessionStorage.getItem("token"),
                checkedData: {
                    // sendData: ['province_name'], // 默认选中值
                    // typeOptions: {
                    //     lazy: true, // 开启懒加载
                    //     lazyLoad: this.lazyLoad,
                    // },
                    value: "code",
                    label: "name",
                    children: 'children',
                    leaf: 'leaf'
                },
                showMap: false,
                addQuery: {
                    token: sessionStorage.getItem("token"),
                    id: 0,
                    types: 1,
                    org_com: "",
                    org_provinceid: "",
                    org_cityid: "",
                    org_areaid: "",
                    org_town_id: '',
                    org_address: "",
                    org_mobile: "",
                    org_license: "",
                    org_logo: "",
                    org_bgpic: "",
                    org_pics: [],
                    org_remark: "",
                    apply_realname: "",
                    apply_mobile: "",
                    org_video: "test",
                    org_longitude: "",
                    org_latitude: "",
                    apply_time: "",
                    account: "",
                    is_status: 1,
                    issuing_authority: "",
                    checkDate: [],
                    legal_person: "",
                    credit_code: "",
                    created_date: "",
                    reg_address: "",
                    cert_valid_start: "",
                    cert_valid_end: "",
                    reg_capital: "",
                    organizer: "",
                    eva_level: "",
                    is_charitable: 1,
                    is_support: 1,
                    is_public_equity: 1,
                    business_scope: "",
                    organization: '',
                    sport_type: '',
                    site_type: '',
                    join_examine: 1
                },
                rules: {
                    // act_level: [{ required: true, message: '请选择', trigger: 'blur' }],
                    org_com: [{ required: true, message: '请输入', trigger: 'blur' }],
                    org_areaid: [{ required: true, message: '请选择', trigger: 'blur' }],
                    org_address: [{ required: true, message: '请输入', trigger: 'blur' }],
                    org_longitude: [{ required: true, message: '请选择', trigger: 'blur' }],
                    org_mobile: [{ required: true, message: '请输入', trigger: 'blur' }],
                    account: [{ required: true, message: '请输入', trigger: 'blur' }],
                    org_license: [{ required: true, message: '请上传', trigger: 'blur' }],
                    org_logo: [{ required: true, message: '请上传', trigger: 'blur' }],
                    org_bgpic: [{ required: true, message: '请上传', trigger: 'blur' }],
                    org_remark: [{ required: true, message: '请输入', trigger: 'blur' }],
                    apply_realname: [{ required: true, message: '请输入', trigger: 'blur' }],
                    // apply_mobile: [{ required: true, message: '请输入', trigger: 'blur' }],
                    issuing_authority: [{ required: true, message: '请输入', trigger: 'blur' }],
                    legal_person: [{ required: true, message: '请输入', trigger: 'blur' }],
                    credit_code: [{ required: true, message: '请输入', trigger: 'blur' }],
                    created_date: [{ required: true, message: '请输入', trigger: 'blur' }],
                    reg_address: [{ required: true, message: '请输入', trigger: 'blur' }],
                    checkDate: [{ required: true, type: 'array', message: '请选择', trigger: 'blur' }],
                    reg_capital: [{ required: true, message: '请输入', trigger: 'blur' }],
                    organizer: [{ required: true, message: '请输入', trigger: 'blur' }],
                    eva_level: [{ required: true, message: '请选择', trigger: 'blur' }],
                    business_scope: [{ required: true, message: '请输入', trigger: 'blur' }],
                    organization: [{ required: true, message: '请输入 职位名称:姓名，换行继续输入', trigger: 'blur' }],
                    // sport_type: [{ required: true, message: '请选择', trigger: 'blur' }],
                    site_type: [{ required: true, message: '请选择', trigger: 'blur' }]
                },
            };
        },
        computed: {
          is_mass_organizations_self(){
            return this.source === 'mass_organizations_self'
          }
        },
        async created() {
            await this.intAllWzArea()

            //  设置来源页面
            this.source = this.$route.query.source || ''

            // await this.getAreaList();
            await this.initSportTypes()
            await this.initSportSiteList();
            if (this.$route.query.id) {
                this.postType = 1;
                const obj = {
                    token: sessionStorage.getItem("token"),
                    id: this.$route.query.id,
                };
                shangxiehuixiangqing(obj).then(({ data: res }) => {
                    console.log("resss", res);
                    this.$nextTick(() => {
                        let areaArray = [res.org_areaid];
                        if (res.org_town_id) {
                            areaArray.push(res.org_town_id);
                        }
                        this.areaArray = areaArray;
                        const Query = {
                            token: sessionStorage.getItem("token"),
                            id: this.$route.query.id,
                            types: 1,
                            org_com: res.org_com,
                            org_areaid: res.org_areaid,
                            org_town_id: res.org_town_id,
                            org_address: res.org_address,
                            org_mobile: res.org_mobile,
                            org_license: res.org_license,
                            org_logo: res.org_logo,
                            org_bgpic: res.org_bgpic,
                            org_pics: res.org_pics ? res.org_pics : [],
                            org_remark: res.org_remark,
                            apply_realname: res.apply_realname,
                            apply_mobile: res.apply_mobile,
                            org_video: res.org_video,
                            org_longitude: res.org_longitude,
                            org_latitude: res.org_latitude,
                            apply_time: res.apply_time,
                            is_status: res.is_status,
                            issuing_authority: res.issuing_authority,
                            checkDate: [res.cert_valid_start, res.cert_valid_end],
                            legal_person: res.legal_person,
                            credit_code: res.credit_code,
                            created_date: res.created_date,
                            reg_address: res.reg_address,
                            account: res.account,
                            cert_valid_start: res.cert_valid_start,
                            cert_valid_end: res.cert_valid_end,
                            reg_capital: res.reg_capital,
                            organizer: res.organizer,
                            eva_level: res.eva_level,
                            is_charitable: res.is_charitable,
                            is_support: res.is_support,
                            is_public_equity: res.is_public_equity,
                            business_scope: res.business_scope,
                            organization: res.organization,
                            join_examine: res.join_examine,
                            site_type: res.site_type.split(','),
                            sport_type: res.sport_type,
                            act_level: res.act_level
                        };
                        this.addQuery = Query;
                        console.log("_Query", Query)

                        // 初始赋值活动类型复选框
                        if (Query.sport_type) {
                            console.log("_Query.sport_type", Query.sport_type)
                            this.checkSportTypesList = Query.sport_type.split(",").map(item=>Math.floor(item));
                        }
                    });
                });
            } else {
                this.postType = 0;
            }
        },
        methods: {
            async intAllWzArea(){
              const allWzAreaResp = await getAllWzArea()
              console.log("_allWzArea", allWzAreaResp)
              const { result, data, msg } = allWzAreaResp.data;
              if(result === 1){
                this.allWzArea = data;
                console.log(this.allWzArea)
              }
            },
            /** 初始化活动类型*/
            initSportTypes(){
                //  获取活动类型
                getBusinessSportTypeList({
                    limit: -1,
                    token: sessionStorage.getItem("token"),
                }).then(resp=>{
                    this.sportTypes = resp.data.data.map(item=>({id:item.id, title:item.title}));
                })
            },
            /** 初始化场地列表*/
            initSportSiteList() {
              getBusinessSportSiteList({
                  limit: -1,
                  token: sessionStorage.getItem("token"),
              }).then(resp=>{
                  // console.log("_getBusinessSportSiteList", resp)
                  this.sportSites = resp.data.list.map(item=>({value:item.id, label:item.title}));
              })
            },
            onSubmit() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        if (!this.postType) {
                            this.addQuery = { ...this.addQuery, sport_type: this.checkSportTypesList.join(','), site_type: this.addQuery.site_type.length ? this.addQuery.site_type.join(',') : '' }
                            addBusinessassociation(this.addQuery).then(({ data: res }) => {
                                if (res.result === 1) {
                                    this.$message(res.msg);
                                    this.$router.back();
                                }
                                if (res.result === 0) {
                                  this.$message({
                                    message: res.msg,
                                    type: "error",
                                    duration: "2000",
                                  });
                                  this.addQuery.site_type = '';
                                  return false;
                                }
                            });
                        } else {
                            console.log("this.addQuery", this.addQuery);
                            this.addQuery = { ...this.addQuery, sport_type: this.checkSportTypesList.join(','), site_type: this.addQuery.site_type.join(',') }
                            editBusinessassociation(this.addQuery).then(({ data: res }) => {
                                if (res.result === 1) {
                                    this.$message({
                                      message: res.msg,
                                      type: 'success'
                                    });
                                    this.$router.back();
                                }
                                if (res.result === 0) {
                                  this.$message({
                                    message: res.msg,
                                    type: "error",
                                    duration: "2000",
                                  });
                                  this.addQuery.site_type = '';
                                  return false;
                                }
                            });
                        }
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            GetJWD() {
              // this.$refs.AmapCom.initMap('org_address', 0, this.addQuery.org_address, this.addQuery.org_longitude, this.addQuery.org_latitude)
              this.$refs.searchAddressRef.init({ type:'address', address: this.addQuery.org_address, lng: this.addQuery.org_longitude, lat: this.addQuery.org_latitude })
            },
            AddrConfirm(res) {
                console.log("onAddrConfirm", res);
                this.showMap = false;
                this.addQuery.org_address = res.address;
                this.addQuery.org_longitude = res.lng;
                this.addQuery.org_latitude = res.lat;
            },
            changList(val) {
              console.log("_changeList", val)
                this.addQuery.org_areaid = val[0];
                this.addQuery.org_town_id = val[1] || '';
            },
            async getAreaList() {
                try {
                    const res = await getWzArea();
                    const result = res.data.data;
                    result.forEach((item) => {
                        item.value = item.code;
                        item.label = item.name;
                    });
                    this.areaList = result;
                } catch (error) {
                    console.log(error);
                }
            },
            async lazyLoad(node, resolve) {
                const level = node.level;
                let result;
                let res;
                let param;
                switch (level) {
                    case 0: // 一级
                        res = await getWzArea();
                        result = res.data.data;
                        console.log("_result", result)
                        result.forEach((item) => {
                            item.value = item.code;
                            item.label = item.name;
                            // 国家级|市级
                            item.leaf = item.code === "330300000000" || item.code === "100000000000";
                        });
                        break;
                    case 1: // 二级
                        param = {
                            code: node.data.code,
                            pid: node.data.id,
                        };
                        res = await getWzArea(param);
                        result = res.data.data;
                        // console.log(result)
                        result.forEach(item => {
                            item.value = item.code;
                            item.label = item.name;
                            item.leaf = level >= 1
                        });
                        break;

                    default:
                        result = [];
                        break;
                }
                resolve(result);
            },
            progress(event, file, fileList) {
                console.log("event", event, "file", file, "fileList", fileList);
                // this.addquery.font_url.push({ name: file })
            },
            // 文件数量过多时提醒
            handleExceed() {
                // this.$message({ type: 'info', message: '最多支持5个附件上传' })
            },
            beforeUpload(file) {
                console.log(file);
                const promise = new Promise((resolve) => {
                    this.$nextTick(function() {
                        resolve(true);
                    });
                });
                return promise; // 通过返回一个promis对象解决
            },
            handleAvatarSuccess(response, file, fileList) {
                console.log("res", response, name);
                if (response.result === 1) {
                    this.$message({
                        message: response.msg,
                        type: "success",
                        duration: "2000",
                    });
                    this.addQuery.org_bgpic = response.pic_url;
                    console.log("this.addQuery.org_bgpic", this.addQuery.org_bgpic);
                }
            },
            handleAvatarlicense(response, file, fileList) {
                console.log("res", response);
                if (response.result === 1) {
                    this.$message({
                        message: response.msg,
                        type: "success",
                        duration: "2000",
                    });
                    this.addQuery.org_license = response.pic_url;
                } else {}
            },
            handleAvatarlogo(response, file, fileList) {
                console.log("res", response);
                if (response.result === 1) {
                    this.$message({
                        message: response.msg,
                        type: "success",
                        duration: "2000",
                    });
                    this.addQuery.org_logo = response.pic_url;
                } else {}
            },
            handleAvatarVideo(response, file, fileList) {
                console.log("res", response);
                if (response.result === 1) {
                    this.$message({
                        message: response.msg,
                        type: "success",
                        duration: "2000",
                    });
                    this.addQuery.org_video = response.video_url;
                } else {}
            },
            handleAvatarPics(response, file, fileList) {
                console.log("res", response);
                if (response.result === 1) {
                    this.$message({
                        message: response.msg,
                        type: "success",
                        duration: "2000",
                    });
                    this.addQuery.org_pics.push({
                        name: response.pic_url,
                    });
                    console.log("this.addQuery.org_pics", this.addQuery.org_pics);
                } else {}
            },
            // pickerOptions: {
            //     disabledDate(time) {
            //         return time.getTime() <= Date.now();
            //     },
            // },
            // 入住日期切换
            changeCheckDate(time) {
                if (time) {
                    this.addQuery.cert_valid_start = time[0];
                    this.addQuery.cert_valid_end = time[1];
                } else {
                    this.addQuery.cert_valid_start = "";
                    this.addQuery.cert_valid_end = "";
                }
            },
        },
    };
</script>

<style lang="less">
    .el-scrollbar__wrap {
        height: 200px;
    }

    .imgboxList {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        .imgBox {
            margin-right: 10px;
            margin-bottom: 10px;
            width: 288px;
            height: 288px;
        }

        .imgs {
            width: 100%;
            height: 100%;
            opacity: 1;
            background: #ffffff;
            border: 1px dashed rgba(213, 213, 213, 0.5);
            border-radius: 5px;
        }
    }

    .body {
        display: flex;
        flex-direction: column;

        .title {
            opacity: 1;
            font-size: 30px;
            font-weight: 800;
            text-align: left;
            color: #2e2e2e;
            letter-spacing: 0px;
            margin-bottom: 35px;
            display: flex;
            flex-direction: row;
            align-items: center;

            .fansk {
                margin-top: 30px;
                margin-left: 32px;
            }
        }

        .fromsss {
            margin-top: 54px;
        }
    }

    .el-upload-list--picture .el-upload-list__item {
        display: none;
    }

    .file {
        display: none;
    }

    .fromsss {
        margin-top: 54px;
    }

    .imgbox {
        width: 288px;
        //height: 88px;
        opacity: 1;
        background: rgba(0, 0, 0, 0);
        border-radius: 5px;
        position: relative;

        .imgs {
            width: 100%;
            height: 100%;
            cursor: pointer;
        }

        .imgs:hover {
            opacity: 0.8;
        }

        .close {
            position: absolute;
            right: 10px;
            top: 10px;
            width: 20px;
            height: 20px;
            opacity: 1;
            z-index: 999;
            background: #e54848;
            border-radius: 50%;
        }
    }
    .imgbox{
      position: relative;
      width: 110px!important;
    }
    .img-self{
      width: 110px!important;
    }
</style>
